var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 11.25H6.75V12.75H17.25V11.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5H3C2.6023 16.4996 2.22101 16.3414 1.9398 16.0602C1.65859 15.779 1.50042 15.3977 1.5 15V9C1.50042 8.6023 1.65859 8.22101 1.9398 7.9398C2.22101 7.65859 2.6023 7.50042 3 7.5H21C21.3977 7.50042 21.779 7.65859 22.0602 7.9398C22.3414 8.22101 22.4996 8.6023 22.5 9V15C22.4996 15.3977 22.3414 15.779 22.0602 16.0602C21.779 16.3414 21.3977 16.4996 21 16.5ZM3 9V15H21V9H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlates);
export default __webpack_public_path__ + "static/media/ic-plates.42cd798548e97fcde6c4119ef8b0ec3c.svg";
export { ForwardRef as ReactComponent };